import * as React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { observer } from 'mobx-react';
import { confirmDialogStore } from '../store/ConfirmDialog';
import BaseButton from './BaseButton';

const BaseCofirmDialog = observer(() => {
  const handleClose = async () => {
    confirmDialogStore.close();
  };

  const confirm = async () => {
    if (confirmDialogStore.confirmAction) {
      await confirmDialogStore.confirmAction();
    }
    handleClose();
  };

  const close = async () => {
    if (confirmDialogStore.closeAction) {
      await confirmDialogStore.closeAction();
    }
    handleClose();
  };

  return (
    <>
      <Dialog
        open={confirmDialogStore.open}
        onClose={close}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          {confirmDialogStore.title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            {confirmDialogStore.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <BaseButton
            text='Cancel'
            variant='outlined'
            color='primary'
            onClick={close}
            isDisabled={confirmDialogStore.isProcessing}
            spinner={confirmDialogStore.isProcessing}
            customStyle={{ marginRight: '10px' }}
          />
          <BaseButton
            text='Confirm'
            variant='contained'
            color='primary'
            isDisabled={confirmDialogStore.isProcessing}
            spinner={confirmDialogStore.isProcessing}
            onClick={confirm}
          />
        </DialogActions>
      </Dialog>
    </>
  );
});

export default BaseCofirmDialog;
